/* Original name @uswitch/trustyle.palette */

import { createContext, forwardRef, useContext } from 'react'

const sw = cases => (prop, ...data) => {
  const f = {}.hasOwnProperty.call(cases, prop) ? cases[prop] : cases.default

  return f instanceof Function ? f(...data) : f
}

const PaletteContext = createContext({})
export const PaletteProvider = PaletteContext.Provider

const createSx = (palette = {}, obj = {}) =>
  !obj
    ? {}
    : Object.entries(obj).reduce(
        (acc, [key, value]) =>
          sw({
            object: () => ({ ...acc, [key]: createSx(palette, value) }),
            function: () => ({ ...acc, [key]: value(palette) }),
            default: () => {
              const { mobileBackgroundColor, backgroundColor } = palette

              if (mobileBackgroundColor && key === 'backgroundColor') {
                return palette[value]
                  ? {
                      ...acc,
                      backgroundColor: [mobileBackgroundColor, backgroundColor, backgroundColor],
                    }
                  : acc
              } else {
                return palette[value] ? { ...acc, [key]: palette[value] } : acc
              }
            },
          })(typeof value),
        {},
      )

export const usePalette = () => {
  const palette = useContext(PaletteContext)
  return palette
}

/**
   TODO:
   To prevent margin collapse, which should use emotion utils to read
   the parent styles and only set the vertical padding when a padding
   is 0 or not set

   Similarly, in order to prevent margin collapse for palettes, you
   should add the following snippet as high up in your document as
   possible

   <style>.palette{padding-top:0.05px;padding-bottom:0.05px}</style>
 */

export const Palette = forwardRef(({ children, className = '', px = {}, ...props }, ref) => {
  const palette = usePalette()
  const sx = createSx(palette, px)

  return (
    <props.as {...props} sx={{ '&.palette': sx }} className={`palette ${className}`} ref={ref}>
      {children}
    </props.as>
  )
})

export default Palette
